export const masterMixin =  {

    data(){
        return{
            listItemObject:{"items":[], "totalCount":0, "totalAmount":null},
            searchValue:'',
            startIndex:0,
            scrollPositionTop:0,
            loadMore:false,
            showPlaceHolder:false,
            timeoutid:null
        }
    },

    methods: {

        onScroll (event) {
            var element = event.target;
            if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 150 <= element.documentElement.clientHeight)
            {
                console.log('scrolled');
                if(this.listItemObject.items.length < this.listItemObject.totalCount){
                    this.fn_loadItems();
                }
            }
        },

        fn_debounceSearch: function(){
             if (this.timeoutid != null){
                clearTimeout(this.timeoutid);
             }

            this.timeoutid = setTimeout(() => { 
                this.fn_searchItem();
            },300);
        },

       fn_deleteMasterItem: function(type, itemId, callback){
            let self = this;
            this.deleteData(type, itemId, {
                onSuccess: function(response){
                    console.log(response);
                    callback(JSON.parse(response));
                }, 
                onError: function(error){
                  console.log(error);
                }
            });     
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/masters/master_mixin.js